<automata-datetime-picker
  [datetime]="initialDateValue"
  (datetimeChanged)="onSelectedDate($event)"
  (invalidDate)="valid = !$event"
  [label]="label"
></automata-datetime-picker>
